// src/view/AppMain.js
import React, { useEffect, useRef, useState } from 'react';
import { Box, Typography,  } from '@mui/material';
import { styled } from '@mui/material/styles';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import CostAvSvg from '../asset/costav.svg';
import { useSetAtom } from 'jotai';
import { simulationRuleAtom } from '../value/AppModel';
import AppUtil from '../util/AppUtil';
import Rules from './Rules';
import Starter from './Starter';
import { AppStyle } from '../value/AppConst';
import RecordsInput from './RecordsInput';
import Result from './Result';
import { Plain } from './StyledViews';

const MaxWidth = 1200;

const OutterBox = styled(Box)({
    width: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center',
});
const InnerBox = styled(Box)({
    maxWidth: MaxWidth,
});
const TitleBox = styled(Box)({
    display: 'flex', alignItems: 'center', padding: 16,
    borderBottom: '1px solid ' + AppStyle.PrimaryRGB
});

const Step = styled(Box)({
    flexGrow: 1, padding: 16, margin: '0 2px', backgroundColor: AppStyle.PrimaryRGB, color: 'white', borderRadius: 4,
    textAlign: 'center'
});

export default function AppMain() {
    const setSimulationRule = useSetAtom(simulationRuleAtom);

    // 로컬 스토리지에서 규칙을 읽어오기.
    useEffect(()=>{
        const rule = AppUtil.readRuleStored();
        setSimulationRule(rule);
    }, []);

    return (
        <OutterBox>
            <InnerBox>
                <TitleBox>
                    <img src={CostAvSvg} alt="CostAv" style={{height: 40, marginRight: 10}} />
                    <Typography variant="h5">
                        적립식 분할매수 시뮬레이터 
                    </Typography>
                    <span style={{flexGrow:1, color:'#799'}}>(를 사용하시는 데 필요한 조건은 아무것도 없습니다.)</span>
                </TitleBox>
                <Box style={{display: 'flex'}}>
                    <Plain style={{color:'black'}}>
                        <p>
                        적립식 분할매수 시뮬레이터는 주식의 분할매수 전략을 시뮬레이션하여 자신에게 맞는 매매 규칙을 찾는 도구입니다. (모바일 버전은 없습니다)<br />
                        관심있는 종목의 과거 주가 데이터를 입력하고, 자신이 선택한 규칙에 따라 매매를 시뮬레이션한 후 
                        그 결과를 보여드립니다.</p>
                        <p>
                        적립식 분할매수 방식의 매매는 박스권에서 움직이는 종목에 유리합니다. 그리고 존버의 스피릿을 필요로 합니다.<br />
                        계속 오르거나 내리는 종목의 경우에는 어떤 식으로든 분할매수의 의미가 없겠죠.<br />
                        자신이 관심있는 종목이 어떤 패턴을 보이는지 잘 보신 후 장기간 오르내림을 반복하고 있다면 실험해 보세요.
                        </p>
                        <p>아래는 작업 순서입니다.</p>
                    </Plain>
                    <Box style={{
                            width: '70%', padding: "0 16px 0 16px", border: AppStyle.BorderCCC, borderRadius: 4,
                            margin: '16px 0 16px 16px', color: '#555'
                        }}
                    >
                        <Plain>
                            <p>
                            <span>구글 드라이브나 구글 시트를 1도 모르시는 분들을 위해 간단히 설명드립니다. </span> <br/><span style={{color:'#779'}}>계속 몰라도 된다면 좋겠지만, 이 도구를 사용하시려면 어쩔 수 없습니다.</span>
                            </p>
                            <p>
                            구글 드라이브를 사용하려면 구글 계정만 있으면 됩니다. 유튜브를 볼 수 있다면 구글 계정이 있다는 의미입니다.
                            구글 드라이브로 가신 다음에 왼쪽 위의 "신규+" 버튼을 누르고 "Google 스프레드 시트"를 선택하면 구글 시트를 새로 만들 수 있습니다. 구글 시트는 엑셀과 같은 앱입니다.<br/>
                            참고로, 무료 구글 계정에는 15GB의 저장공간이 제공됩니다. 맘껏 사용하시면 됩니다. <strong>(광고 아님 주의)</strong>
                            </p>
                            <p>
                            <a href="https://drive.google.com/drive/home" target="_blank" rel="noopener noreferrer"
                                style={{textDecoration: 'none', color: '#1a73e8'}}
                            >구글 드라이브 바로가기 <OpenInNewIcon fontSize="small" /></a>
                            </p>
                        </Plain>
                    </Box>
                </Box>
                <Box style={{display:'flex', alignItems:'center', marginBottom: 16}}>
                    <Step>구글시트 함수입력</Step><ArrowForwardIcon style={{color:AppStyle.PrimaryRGB}} />
                    <Step>주가 데이터 붙여넣기</Step><ArrowForwardIcon style={{color:AppStyle.PrimaryRGB}} />
                    <Step>데이터 확인하기</Step><ArrowForwardIcon style={{color:AppStyle.PrimaryRGB}} />
                    <Step>매매 규칙 설정</Step><ArrowForwardIcon style={{color:AppStyle.PrimaryRGB}} />
                    <Step>시뮬레이션 실행</Step><ArrowForwardIcon style={{color:AppStyle.PrimaryRGB}} />
                    <Step>결과 확인</Step>
                </Box>
                <Starter />
                <RecordsInput />
                <Rules />
                <Result />
                <Box style={{
                    backgroundColor: '#cdf', color: 'white', fontSize: '0.75rem', padding: 8, textAlign: 'center'
                }}>
                    Copyright © 2025 ignolab.com. All rights reserved. 아님말쿠나마타타!
                </Box>
            </InnerBox>
        </OutterBox>
    );
}

/*

전종목 시세: https://data.krx.co.kr/contents/MDC/MDI/mdiLoader/index.cmd?menuId=MDC0201020101





앱을 사용하는 방법(순서대로)
    - 사용자는 분석하려는 티커, 시작날짜, 종료날짜 입력
    - 앱이 만들어준 "=googlefinance(...)" 함수를 안내에 따라 구글시트에 입력
    - 구글시트에 출력된 데이터를 복사하여 앱의 "주가데이터"에 붙여넣고 "시작" 버튼
    - 앱은 데이터를 검토한 후 캔들차트 표시 또는 오류가 있는 경우 날짜와 오류내용 표시.
    - 사용자는 규칙을 설정하고 "다음" 버튼을 누름
    - 앱은 규칙에 따라 매수, 매도를 하고 결과를 출력

UI 종합:
사용자가 들어오면 전체 과정을 볼 수 있음.
    - 시작하기
    - 주가 데이터 붙여넣기
    - 매매 규칙
    - 결과
    4개의 섹션으로 구분됨. 상태에 따라 매매 규칙, 결과 섹션은 disabled color
    전체를 스크롤할 수 있음.
    우측 상단에 각 섹션으로 이동할 수 있는 UI가 fixed link들로 표시됨.

[섹션 1: 시작하기] Starter.js

    입력 필드: Ticker, 시작일, 종료일 (티커는 Google Finance에서 지원하는 형식으로 입력. 코스피, 코스닥의 경우 어떻게 해야하는지 안내 필요. 작은 버튼으로 클릭하면 검사해서 변경해 주기)
    출력 필드: Google Sheets 연동 안내: 사용자가 복사할 수 있도록 =GOOGLEFINANCE(...) 함수를 자동으로 생성하여 보여줍니다.
    버튼: "복사" 버튼을 클릭하면 클립보드에 복사되도록 합니다. 상세한 안내 메시지를 그림과 함께 표시합니다.
    버튼: "다음" 버튼을 클릭하면 "주가 데이터 붙여넣기" 섹션으로 이동.

[섹션 2: 주가 데이터 붙여넣기] RecordsInput.js
    - Multiline TextField를 크게 배치. (주가 데이터 붙여넣기 버튼 필요)
    - 버튼: "데이터 확인" 버튼을 클릭하면 사용자가 붙여넣은 텍스트 데이터를 파싱하여 날짜, 시가, 고가, 저가, 종가, 거래량 객체의 배열로 변환하는 함수를 실행하고 정보에 문제가 없는지 확인.
    - 차트: 데이터가 성공적으로 로드되면 여기에 캔들 차트를 표시.
    - 테이블: 데이터가 성공적으로 로드되면 테이블 형태로 날짜, 시가, 고가, 저가, 종가, 거래량을 표시.

[섹션 3: 매매 규칙] Rules.js
    - 최소 거래 횟수. 이 횟수만큼 거래하지 않았다면 팔지 않음 (minimalTradeTimes, 최소값=1, 최대값=10)
    - 기본 매수 간격 (일 단위) (buyInterval, 최소값=3, 최대값=40)
    - 기본 매수 금액 (원 단위) (buyAmount, 최소값=10, 최대값=10,000,000)
    - 상승 시 매수간격 조절 배율 (예: 0.8) (bullIntervalFactor, 최소값=0.3, 최대값=2.0)
    - 하락 시 매수간격 조절 배율 (예: 1.5) (bearIntervalFactor, 최소값=0.3, 최대값=2.0)
    - 손실을 보고 있을 때 매수금액 증액 비율 최대값 (1.5배) (avgDownFactorMax, 최소값=1.0, 최대값=3.0) : (1.5-1) * 손실비율. ex: (1.5-1) * 0.2 = 0.1 => 1.1배 매수.
    - 무시할 수 있는 상승 또는 하락폭 (예: 5%) (acceptableChange, 최소값=0.02, 최대값=1.0)
    - 전체 매도할 수익률 (예: 30%) (exitOnProfit, 최소값=0.1, 최대값=3.0)
    - 부분 매도 시작 수익률 (예: 20%) (partialSellOnProfit, 최소값=0.1, 최대값=3.0)
    - 부분 매도 비중 (예: 25%) (partialSellThreshold, 최소값=0.1, 최대값=0.5)
    - 급격한 하락에 대한 매수 기준 (15% 이내) (suddenDropBuyThreshold, 최소값=0.1, 최대값=0.5)
    - 급격한 하락 시 매수 금액 조절 (0.2배) (suddenDropBuyFactor, 최소값=0, 최대값=1.0) 이 기간이 코비드 기간처럼 장기화 될 수 있으므로 1보다 크지 말아야 한다. 값이 0이면 급격한 하락에 대한 매수는 하지 않음.
    - 롤링 최고가 기간 (5일) (rollingHighPeriod, 최소값=1, 최대값=30) $suddenDropBuyThreshold 적용의 기준이 되는 값. 현재 가격이 $rollingHighPeriod 기간의 최고값 대비 $suddenDropBuyThreshold 만큼 떨어져 있는 경우 매수한다. 또한 급락매수한 경우 이 값과 동일한 기간 내에 다시 매수하지는 않는다.
    # 수익이 partialSellOnProfit 퍼센트 이상인 경우 보유주식수의 partialSellThreshold 퍼센트 매도하고 매수하지 않음.
    - 버튼: "가상 매매 시뮬레이션 시작" 버튼을 누르면 설정된 규칙에 따라 매매 시뮬레이션을 실행하여 결과 값을 만들어 냄.
    - 로컬스토리지: 규칙 정보는 로컬 스토리지에 저장함.

[섹션 4: 결과] Result.js
    - 핵심 요약: 최종 수익금, 투자 원금, 수익률을 눈에 띄게 표시 (MUI Card 컴포넌트 활용)
    - 결과 차트: 캔들 차트 위에 매수(🔼) 및 매도(🔽) 시점을 아이콘으로 표시해 시각적으로 이해를 도움.
    - 매매 기록: output_test_costav.txt처럼 모든 거래 내역을 테이블(MUI Table) 형태로 상세히 출력.
    - 버튼: "결과 다운로드" 버튼을 클릭하면 거래 내역을 TSV 파일로 다운로드할 수 있도록 함.
    - 버튼: "결과 복사" 버튼을 클릭하면 거래 내역을 클립보드에 복사할 수 있도록 함.


*/